import { useT } from "../../../../i18n/I18nProvider";
import { type StaffUser } from "../../../../lib/auth";
import { SettingsSubsection } from "../subsection";
import { PAYMENT_TABS } from "./tabs";

/**
 * Settings -> Payments.
 *
 * How this desk lets an invoice be settled: the list of methods, and the Stripe
 * account behind the one of them that takes a card. Each is its own routed tab,
 * listed in a side menu - the third shelf of this shape, after Integrations and
 * Phone.
 */
export function PaymentsSettings({ user }: { user: StaffUser }) {
  const t = useT();
  return (
    <SettingsSubsection
      base="/settings/payments"
      tabs={PAYMENT_TABS}
      user={user}
      navLabel={t("settings.tabs.payments")}
      i18nPrefix="settings.paymentsNav"
    />
  );
}
